

export enum PaymentMethodCategoryEnum  {
    Card = "Card",
    CustomerWallet = "Wallet",
    AlternativePaymentMethod = "APM"
}